"use client";

import { c as _c } from "react/compiler-runtime";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import type React from "react";
import { Suspense, useEffect } from "react";
import { ConfirmProvider } from "@/components/global/confirm-context";
import { PopLoading } from "@/components/pop-ui/pop-loading";
import { PopToast } from "@/components/pop-ui/pop-toast";
import { fixNodeOperationErrors } from "@/lib/utils.client";
import { AuthProvider } from "./auth-provider";
import { CheckUserExistsPollingProvider } from "./check-user-exists-polling-provider";
import { GlobalConfigProvider } from "./global-config-context";
import { ORPCProvider } from "./orpc-provider";
import { QueryProvider } from "./query-provider";
import { RealtimeBridgeProvider } from "./realtime-bridge-provider";
import { RealtimeProvider } from "./realtime-provider";
import { RouteHistoryProvider } from "./route-history-provider";
import { ThemeProvider } from "./theme-provider";
import TranslationsProvider from "./translations-provider";
import { TurnstileProvider } from "./turnstile-provider";
interface ProvidersProps {
  children: React.ReactNode;
  locale: string;
  namespaces: string[];
  resources: any;
}
export function Providers(t0) {
  const $ = _c(10);
  const {
    children,
    locale,
    namespaces,
    resources
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PopToast />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PopLoading fullScreen={true} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} disableTransitionOnChange={true}><QueryProvider>{t2}<ORPCProvider><RealtimeProvider><RealtimeBridgeProvider><NuqsAdapter><AuthProvider><CheckUserExistsPollingProvider><GlobalConfigProvider initialConfig={null}><TurnstileProvider><ConfirmProvider><Suspense fallback={t3}><RouteHistoryProvider>{children}</RouteHistoryProvider></Suspense></ConfirmProvider></TurnstileProvider></GlobalConfigProvider></CheckUserExistsPollingProvider></AuthProvider></NuqsAdapter></RealtimeBridgeProvider></RealtimeProvider></ORPCProvider></QueryProvider></ThemeProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== locale || $[6] !== namespaces || $[7] !== resources || $[8] !== t4) {
    t5 = <TranslationsProvider namespaces={namespaces} locale={locale} resources={resources}>{t4}</TranslationsProvider>;
    $[5] = locale;
    $[6] = namespaces;
    $[7] = resources;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp() {
  fixNodeOperationErrors();
}